export default __webpack_public_path__ + "static/media/43.913f553b.jpg";